import store from '@/store'
import _ from 'lodash'

const watchers = new WeakMap()
const toggleFunctions = new WeakMap()

const elementLoader = {
  bind(el, binding) {
    const params = binding.value
    const elementStyle = window.getComputedStyle(el)

    watchers[el] = store.watch((state, getters) => getters['ui/activeEndpoints'], configs => {
      const endpoints = _.isArray(params.endpoint) ? params.endpoint : [params.endpoint]
      const showLoader = _.some(configs, cfg => {
        const matchesEndpoint = _.some(endpoints, endpoint => _.includes(cfg.url, endpoint))
        if(!matchesEndpoint) {
          return
        }
        if(params.matcher) {
          const data = cfg.method === 'post' ? cfg.data : cfg.params
          return data && params.matcher(data)
        }
        return true
      })

      toggleFunctions[el] = (toggle) => toggleLoader(binding, el, elementStyle, toggle)
      toggleFunctions[el](showLoader)
    })
  },
  unbind(el) {
    const unwatch = watchers[el]
    if(_.isFunction(unwatch) && toggleFunctions[el]) {
      unwatch()
      watchers.delete(el)
      toggleFunctions[el](false)
      toggleFunctions.delete(el)
    }
  }
}

function toggleLoader(binding, el, elementStyle, toggle) {
  const params = binding.value

  if (toggle) {
    if (elementStyle.position !== '' || elementStyle.position !== 'static') {
      el.style.position = 'relative'
    }

    if (elementStyle.overflow === undefined || elementStyle.overflow !== 'hidden') {
      el.style.overflow = 'hidden'
    }

    el.classList.add('element--is-loading')

    if (params.useSmallLoader) {
      el.classList.add('element--is-loading--small')
    }
    if (params.useLoaderAtTop) {
      el.classList.add('element--is-loading--at-top')
    }
  } else {
    el.classList.remove('element--is-loading')

    if (params.useSmallLoader) {
      el.classList.remove('element--is-loading--small')
    }
    if (params.useLoaderAtTop) {
      el.classList.remove('element--is-loading--at-top')
    }

    el.style.position = ''
    el.style.overflow = ''
  }
}

export default elementLoader
